import { useEffect } from 'react';
import type { VideoAsset } from '../../../services/admin/adminBackendServiceVideoLibraryMixin';

const POLL_MS = 3000;

/** Polls `refresh` on an interval while any video is still PENDING/PROCESSING. */
export function useVideoLibraryPolling(videos: VideoAsset[], refresh: () => Promise<void>) {
  const isProcessing = videos.some((v) => v.status === 'PENDING' || v.status === 'PROCESSING');
  useEffect(() => {
    if (!isProcessing) return undefined;
    const timer = setInterval(() => void refresh(), POLL_MS);
    return () => clearInterval(timer);
  }, [isProcessing, refresh]);
  return isProcessing;
}
